import React, { useEffect, useState, useRef } from "react";
import {
  MessageCircleMore,
} from "lucide-react";
import { useSelector, useDispatch } from "react-redux";
import BaseUrl from "../../constants/BaseUrl";
import { ShowError, ShowSuccess } from "../../utils/ToasFunction";
import { motion } from "framer-motion";
const messageVariants = {
  hidden: { opacity: 0, y: 10 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.2 } },
};

const ShiftInbox = ({ chatId }) => {

  const [chatDetails, setChatDetails] = useState();
  const { allActiveChatSessions, selectedSessionId } = useSelector(
    (state) => state.data
  );
  const dispatch = useDispatch();

  const { currentShift } = useSelector(
    (state) => state.data
  );

  const { loader, loginSuccess, loginError } = useSelector(
    (state) => state.auth
  );



  const GetChatDetails = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}api/support/getChatSessionById/${chatId}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {

          setChatDetails(result?.data);
        }
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    GetChatDetails();
  }, [chatId]);

  const messagesEndRef = useRef(null); // Reference for last message

  // Scroll to bottom on new message
  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [chatDetails?.conversation]);


  return (
    <div className="h-full w-full">
      <div className="h-full bg-[#0381CA]/5 rounded-2xl">
        <div className="flex flex-col h-full w-[97%] mx-auto">
          {/* Chat Messages */}
          <div className="flex-1 h-[99%] overflow-y-auto space-y-4 panelScroll">
            {chatDetails?.conversation.map((msg, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3, delay: index * 0.05 }} // Smooth staggered animation
                className=""
              >
                {msg.support ? (
                  <div className="flex items-start justify-end space-x-2">
                    <div className="bg-themeColor text-white rounded-l-2xl rounded-br-2xl p-3 shadow-sm max-w-xs">
                      <p className="text-sm font-popinsRegular">
                        {msg.message}
                      </p>
                    </div>
                  </div>
                ) : (
                  <div className="flex items-start space-x-1 pt-3">
                    <img
                      src={chatDetails?.customerData?.profileImage}
                      className="size-[45px] rounded-full"
                      alt="logo"
                    />
                    <div className="bg-white/70 p-3 rounded-r-2xl rounded-bl-2xl mt-3 shadow-sm max-w-[30rem]">
                      <p className="text-sm font-popinsRegular text-darkColor">
                        {msg.message}
                      </p>
                    </div>
                  </div>
                )}
              </motion.div>
            ))}
            {chatDetails?.conversation.length === 0 && (
              <div className="w-full">
                <MessageCircleMore color="#FF814E" size={70} />
              </div>
            )}
            <div ref={messagesEndRef} /> {/* Scroll to this element */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShiftInbox;
